import React, { Component } from "react"
import {
    calculateTotalTeamPayment,
    calculateNumberofTeamMembers,
} from "../util/billing_info_utils"
import ButtonGroup from "react-bootstrap/lib/ButtonGroup"
import Button from "react-bootstrap/lib/Button"

const SIDEBAR_SELECTION_TEXT = "You've selected"
const SIDEBAR_UPGRADE_CHARGE_TEXT =
    "You will be charged when your free trial ends."
const SIDEBAR_CARD_SECURITY_TEXT = "Your card data is secure"
const SIDEBAR_CARD_SECURITY_EXPLANATION_TEXT =
    "We don't store card information on our servers. All payments are encrypted and securely processed by Stripe."
const YEARLY_PROMO = "2 months free!"

// todo: show when yearly option is available
const hideMonthlyYearlyOption = true

class BillingInfoSidebar extends Component {
    constructor(props) {
        super(props)
    }

    renderPlanSelectedSection = (
        paymentPlan,
        customer,
        isUpgrade,
        teamMembers,
    ) => {
        const { planName, period, price } = paymentPlan

        const members = calculateNumberofTeamMembers(teamMembers)
        return (
            !customer ||
            (isUpgrade && (
                <div>
                    {isUpgrade && !hideMonthlyYearlyOption && (
                        <div>
                            <ButtonGroup className="payment-modal-button-group">
                                <Button
                                    // onClick={this.props.selectMonthly}
                                    active={true}
                                >
                                    Monthly
                                </Button>

                                <Button
                                    // onClick={this.props.selectYearly}
                                    active={false}
                                >
                                    Yearly
                                </Button>
                            </ButtonGroup>
                            <p className="yearly-promo-subtext">
                                {YEARLY_PROMO}
                            </p>
                        </div>
                    )}
                    {!hideMonthlyYearlyOption && (
                        <p>{SIDEBAR_SELECTION_TEXT}</p>
                    )}
                    <p>
                        <span className="billing-info-sidebar-plan-text">
                            {planName} Plan - {period}
                            <br />
                            {members} seats x ${price} per seat
                        </span>
                    </p>
                    <p className="billing-info-sidebar-plan-text">
                        ${calculateTotalTeamPayment(price, members)} / month
                    </p>
                    {isUpgrade && <p>{SIDEBAR_UPGRADE_CHARGE_TEXT}</p>}
                </div>
            ))
        )
    }

    render() {
        const {
            paymentPlan,
            customer,
            isUpgrade,
            teamMembers,
        } = this.props
        const checkIfCustomerIsNonexistantAndRenderStyle =
            !customer && "billing-info-sidebar-card-info"

        return (
            <div className="billing-info-sidebar-container billing-info-section">
                {this.renderPlanSelectedSection(
                    paymentPlan,
                    customer,
                    isUpgrade,
                    teamMembers,
                )}
                <div className={checkIfCustomerIsNonexistantAndRenderStyle}>
                    <p className="billing-info-sidebar-plan-text">
                        {SIDEBAR_CARD_SECURITY_TEXT}
                    </p>
                    <p>{SIDEBAR_CARD_SECURITY_EXPLANATION_TEXT}</p>
                </div>
            </div>
        )
    }
}

export default BillingInfoSidebar



// WEBPACK FOOTER //
// ./src/components/billing_info_sidebar.jsx